import { addCompanyNameToComment, appointmentSubmiter } from '../appoinment';
import { addPurchaseInfoToComment } from '../eMarket';
import { METRICA_ID } from '../variables';
import { getCookie } from '../utils';
const _afterValidate = (form) => {
    let email = form.email && form.email.value;
    let phone = form.phone && form.phone.value;
    let fname = form.fname && form.fname.value;
    let lname = form.lname && form.lname.value;
    let ycid = getCookie('_ym_uid');
    if (form.classList.contains('appointment__form')) {
        const fnameInput = form.querySelector(`input[name="name"]`);
        fname = fnameInput && fnameInput.value;
    }
    else if (form.classList.contains('cart-purchase-fotm')) {
        const customerId = form.dataset.customerid;
        if (customerId) {
            const emailInput = form.querySelector(`input[name="data[${customerId}][email]"]`);
            const phoneInput = form.querySelector(`input[name="data[${customerId}][phone]"]`);
            const fnameInput = form.querySelector(`input[name="data[${customerId}][fname]"]`);
            const lnameInput = form.querySelector(`input[name="data[${customerId}][lname]"]`);
            email = emailInput && emailInput.value;
            phone = phoneInput && phoneInput.value;
            fname = fnameInput && fnameInput.value;
            lname = lnameInput && lnameInput.value;
        }
    }
    const clientParams = {
        "email": email,
        "phone_number": phone,
        "first_name": fname,
        "last_name": lname,
        "yandex_cid": ycid
    };
    window.ym(METRICA_ID, 'firstPartyParams', clientParams);
    if (form.classList.contains('appointment__form')) {
        addCompanyNameToComment(form);
        appointmentSubmiter(form);
        window.ym(METRICA_ID, 'reachGoal', 'APOINTMENT');
    }
    else if (form.classList.contains('cart-purchase-form')) {
        addPurchaseInfoToComment(form);
        window.ym(METRICA_ID, 'reachGoal', 'ORDER');
        if (form.dataset.producttype == 'trailer') {
            window.ym(METRICA_ID, 'reachGoal', 'ORDERTRAILER');
        }
        if (form.dataset.producttype == 'parts') {
            window.ym(METRICA_ID, 'reachGoal', 'ORDERPARTS');
        }
        form.submit();
    }
    else {
        window.ym(METRICA_ID, 'reachGoal', 'WEBFORMSEND');
        // submiter(form);
        form.submit();
    }
};
export default _afterValidate;
